import { useState } from "react";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";
import { Input } from "../ui/input";
import { Label } from "../ui/label";
import { useAuth } from "../../context/AuthContext";
import { api, errMsg } from "../../lib/api";

const field = "h-12 rounded-xl border-[#D4AF37]/25 bg-[#190317]/60";

export const AccountPanel = () => {
  const { user } = useAuth();
  const [form, setForm] = useState({ current: "", next: "", confirm: "" });
  const [busy, setBusy] = useState(false);
  const set = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  const submit = async (e) => {
    e.preventDefault();
    if (form.next.length < 8) return toast.error("New password must be at least 8 characters");
    if (form.next !== form.confirm) return toast.error("New passwords don't match");
    setBusy(true);
    try {
      await api.post("/auth/change-password", { current_password: form.current, new_password: form.next });
      toast.success("Password changed");
      setForm({ current: "", next: "", confirm: "" });
    } catch (err) {
      toast.error(errMsg(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <form onSubmit={submit} className="max-w-md space-y-4 rounded-[24px] border border-[#D4AF37]/25 bg-[#330B2E]/70 p-6" data-testid="account-panel">
      <h2 className="font-display text-3xl">Account</h2>
      <p className="text-sm text-[#E8D8C8]">Signed in as <span className="text-[#F3E5AB]">{user?.email}</span> (admin)</p>
      <div className="space-y-2">
        <Label htmlFor="pw-cur" className="text-[#F3E5AB]">Current password</Label>
        <Input id="pw-cur" type="password" required value={form.current} onChange={set("current")} className={field} data-testid="current-password-input" />
      </div>
      <div className="space-y-2">
        <Label htmlFor="pw-new" className="text-[#F3E5AB]">New password</Label>
        <Input id="pw-new" type="password" required value={form.next} onChange={set("next")} className={field} data-testid="new-password-input" />
      </div>
      <div className="space-y-2">
        <Label htmlFor="pw-conf" className="text-[#F3E5AB]">Confirm new password</Label>
        <Input id="pw-conf" type="password" required value={form.confirm} onChange={set("confirm")} className={field} data-testid="confirm-password-input" />
      </div>
      <button type="submit" disabled={busy} className="flex w-full items-center justify-center gap-2 rounded-full bg-gold-foil py-3.5 text-sm font-semibold text-[#240620] disabled:opacity-60" data-testid="change-password-btn">
        {busy && <Loader2 size={16} className="animate-spin" />} Change password
      </button>
    </form>
  );
};
